// Object containing all possible block attributes.
const BlockAttributes: Record<string, string> = {
  blockColor: 'data-block-color',
  blockStyle: 'data-block-style',
  id: 'data-id',
  depth: 'data-depth',
  depthChange: 'data-depth-change',
}

export default BlockAttributes
